var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:`cv-toolbar-option ${_vm.carbonPrefix}--toolbar-menu__option`,on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"]))return null;$event.preventDefault();return _vm.$parent.$emit('cv:close')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }